<template>
    <div>
        <h5>{{pageTitle}}</h5>
        <el-input class="search-input" type="text" v-model="searchQuery" :placeholder="userId ? 'Buscar bicicleta' : 'Buscar ciclista'"></el-input>

        <!--======== Reservation / Order Listing Table | Tabela de listagem de Reservas / Pedidos ========-->
        <el-table
            class="mt-3"
            :data="tableReservationData"
            style="width: 100%"
            stripe
            :default-sort = "{prop: 'orderN', order: 'descending'}"
            max-height="720"
            v-loading="loading.books"
        >
            <!-- Expanded Details Column / Coluna detalhes expandidos  -->
            <el-table-column
                type="expand">
                <template slot-scope="props">
                    <b-row>
                        <b-col cols="12" md="4"><p><strong>Data do Pedido:</strong>
                            {{ props.row.createdAt | moment("DD/MM/YYYY [às] H:mm:ss") }}</p></b-col>
                        <b-col cols="12" md="4"><p><strong>Valor Total:</strong> {{ props.row.amount | currency }}</p>
                        </b-col>
                        <b-col cols="12" md="4"><p><strong>Cidade:</strong> {{ props.row.bike.address.city }} -
                            {{ props.row.bike.address.state }}</p></b-col>
                        <b-col cols="12" md="4">
                           <strong>Bicicleta:
                              <el-link
                                 :underline="false"
                                 type="primary"
                                 @click="$router.push(`/bicicleta/${props.row.bike.slug}`)"
                                 size=""
                                 class="link-bike"
                                 round>
                                 {{ props.row.bike.name }}
                              </el-link>
                           </strong>
                        </b-col>
                       <b-col v-if="userId" cols="12" md="4"> <!-- Open Modal Booking /  Abre o Booking Modal -->
                          <p><strong>Valor da bicicleta:</strong>

                             <el-popover
                                placement="top-start"
                                title="AVISO!"
                                width="200"
                                trigger="hover"
                                :content='`Caso não haja a devolução da bicicleta até o dia ${ formatDate(props.row.period.checkout) } às 10:00, será cobrado este valor + taxas.`'>
                                <span slot="reference">{{ props.row.bike.bikeValue | currency }} <i class="el-icon-warning-outline"></i> </span>
                             </el-popover>
                             </p>
                       </b-col>
                         <b-col v-if="userId" cols="12" md="4"> <!-- Open Modal Booking /  Abre o Booking Modal -->
                           <p><strong>Anfitrião:</strong> {{ props.row.owner.firstName }} -
                             {{ props.row.owner.lastName }}</p>
                         </b-col>

                        <b-col cols="12" md="4"> <!-- Open Modal Booking /  Abre o Booking Modal -->
                            <el-button
                                @click="bookModal(props.row)"
                                type="primary"
                                plain
                                size="mini"
                                class="text-uppercase font-weight-bold mb-3"
                                round>Ver detalhes da Reserva →
                            </el-button>
                        </b-col>
                    </b-row>

                </template>
            </el-table-column>

            <!-- Reserve Number Column / Coluna Reserva Número -->
            <el-table-column
                prop="orderN"
                align="center"
                label="Reserva Nº"
                sortable
                column-key="orderN"
                width="130"
            >
                <template slot-scope="props">
                    <el-badge

                      :hidden="!!(userId.length || props.row.logs && props.row.logs.viewed !== undefined)"
                      is-dot class="item"
                    >
                        <el-button
                            @click="bookModal(props.row)"
                            :type="`${props.row.isRequestByOwner ? 'blue' : 'info'}`"
                            :plain="!props.row.isRequestByOwner"
                            size="mini"
                            class="text-uppercase font-weight-bold"
                            round>#{{ props.row.orderN }}
                        </el-button>
                    </el-badge>
                </template>
            </el-table-column>

            <!-- User column / Coluna Usuário -->
            <el-table-column
                :label="userId ? 'Bicicleta' : 'Ciclista'"
                width="130"
            >
                <template slot-scope="scope" >
                  <span v-if="userId">
                     {{ scope.row.bike.name }}
                  </span>
                  <span v-else>
                    {{ scope.row.customer.firstName }} {{ scope.row.customer.lastName }}
                  </span>
                </template>
            </el-table-column>

           <!-- Coluna Chat / Avaliação -->
           <el-table-column
            label="Chat"
            width="70"
           >
              <template slot-scope="book">

                 <div v-if="book.row.status !== 8">
                    <div v-if="userId">
                       <el-badge
                          :hidden="!(book.row.resources && book.row.resources.ownerMessage)"
                          is-dot
                          class="item">
                          <el-button class="btn-chat-row" @click="openChat(book.row)" :title="userId ? 'Fale com o anfitrião' : 'Fale com o(a) ciclista'" icon="el-icon-chat-line-square" circle></el-button>
                       </el-badge>
                    </div>

                    <div v-else>
                       <el-badge
                          :hidden="!(book.row.resources && book.row.resources.customerMessage)"
                          is-dot
                          class="item">
                          <el-button
                             class="btn-chat-row"
                             @click="openChat(book.row)"
                             icon="el-icon-chat-line-square"
                             circle
                             :title="userId ? 'Fale com o anunciante' : 'Fale com o(a) ciclista'"
                          ></el-button>
                       </el-badge>
                    </div>
                 </div>


                 <div v-if="book.row.status === 8">
                    <div v-if="userId">
                       <span v-if="!book.row.resources.customerRating">
                        <el-button
                           class="btn-rating-row"
                           @click="openRating(book.row)"
                           icon="el-icon-star-off"
                           type="rating"
                           circle
                           :title="'Avalie esta reserva'"
                        ></el-button>
                       </span>

                       <span v-else>
                          <el-button
                             class="btn-rating-row"
                             icon="el-icon-star-on"
                             type="success"
                             plain
                             circle
                             title="Você já avaliou esta reserva!"
                          ></el-button>
                       </span>
                    </div>


                    <div v-if="!userId">
                       <span v-if="!book.row.resources.ownerRating">
                        <el-button
                           class="btn-rating-row"
                           @click="openRating(book.row)"
                           icon="el-icon-star-off"
                           type="rating"
                           circle
                           :title="'Avalie o ciclista ref. a essa reserva'"
                        ></el-button>
                        </span>

                       <span v-else>
                          <el-button
                             class="btn-rating-row"
                             icon="el-icon-star-on"
                             type="success"
                             circle
                             plain
                             title="Você já avaliou o ciclista ref. a essa reserva!"
                          ></el-button>
                       </span>
                    </div>
                 </div>

              </template>

           </el-table-column>

           <el-table-column
              prop="leaseModality"
              label="Modalidade"
              sortable
              width="150"
              >
              <template slot-scope="scope">
                 <div v-if="!scope.row.typeOfLeasePeriod">
                    Sob-demanda/dia
                 </div>
                 <div v-else>
                    {{handleLeaseModality(scope.row.leaseModality)}}/{{handleTypeOfLease(scope.row.typeOfLeasePeriod)}}
                 </div>
              </template>
           </el-table-column>

            <!-- Check-in Check-ou Column / Coluna Check-in Check-out -->
            <el-table-column
                prop="typeOfLeasePeriod"
                label="Período"
                width="260"
            >

                <template slot-scope="scope">

                   <!-- Por hora -->
                   <span v-if="scope.row.typeOfLeasePeriod === 'perHour'">
                      Dia <strong>{{scope.row.daySelectedForHourlyRental | moment("utc", "DD/MM/YY")}}</strong> às <strong>{{ scope.row.startHourRental | moment("utc", ' H:mm') }} </strong>até <strong>{{ scope.row.endHourRental | moment("utc", ' H:mm') }}</strong>
                   </span>

                   <!-- Por dia -->
                   <span v-if="scope.row.typeOfLeasePeriod === 'daily' || !scope.row.typeOfLeasePeriod">
                     De <strong>{{scope.row.period.checkin | moment("utc", "DD/MM/YY")}}</strong> até <strong>{{scope.row.period.checkout | moment("utc", "DD/MM/YY")}}</strong>
                   </span>

                   <!-- Por semana -->
                   <span v-if="scope.row.typeOfLeasePeriod === 'perWeek'">
                        <strong>{{scope.row.numberOfRentalWeeks}} {{scope.row.numberOfRentalWeeks > 1 ? 'Semanas' : 'Semana'}}</strong>
                   </span>

                   <!-- Por mês -->
                   <span v-if="scope.row.typeOfLeasePeriod === 'monthly'">
                      <strong>{{scope.row.numberOfMonthsOfLease}} {{scope.row.numberOfMonthsOfLease > 1 ? 'Meses' : 'Mês'}}</strong>
                   </span>


                </template>
            </el-table-column>

            <!-- Status Column / Coluna Status -->
            <el-table-column
                prop="status"
                label="Status"
                sortable
                width="200"
                :filters="filterStatusData"
                :filter-method="filterStatus"
                filter-placement="bottom-end">
                <template slot-scope="scope">
                    <el-tag
                        :title="setStatus(scope.row.status)"
                        style="width: 100%"
                        class="three-dots 75 text-center"
                        effect="dark"
                        :type="statusColor(scope.row.status)"
                        disable-transitions
                        @click="bookModal(scope.row)"
                    >
                        {{ setStatus(scope.row.status) }}
                    </el-tag>
                </template>
            </el-table-column>

            <!-- Date column / Coluna com a data de criacao do pedido -->
            <el-table-column
                prop="createdAt"
                label="Data de Criação"
                sortable
                width="180"
                align="center"
            >
                <template slot-scope="scope">
                    {{ scope.row.createdAt | moment("DD/MM/YYYY [às] H:mm:ss") }}
                </template>
            </el-table-column>
        </el-table>

        <el-pagination
        class="mt-3"
        background
        layout="total, sizes, prev, pager, next"
        :current-page.sync="pagination.page"
        @current-change="changePage"
        @size-change="changeSize"
        :total="pagination.total">
      </el-pagination>

        <!--======== Booking Modal | Modal Reserva ========-->
        <el-dialog
           v-if="booking.bookingDetailsModal"
            top="5vh"
            center
            fullscreen
            class="modal-book v2"
            :class="statusColor(bookObj.status)"
            :visible.sync="booking.bookingDetailsModal"
            :before-close="bookModalClose"
            :close-on-click-modal="false"
            destroy-on-close
        >

           <div class="header-modal" :style="{ background: bookObj.isRequestByOwner ? '#409eff' : '' }">
              <h4><i class="el-icon-document-copy mr-1"></i> {{`Reserva nº #${bookObj.orderN}`}}</h4>
           </div>

           <b-container fluid>
               <b-row align-h="center">


                   <!-- Detalhes da Reserva -->
                   <b-col order-lg="2" cols="12" lg="5">
                       <h5 class="mb-3">Detalhes da Reserva</h5>
                      <el-card :class="`box-card`">
                        <b-list-group>
                           <b-list-group-item :variant="statusColor(bookObj.status)"><strong>Status</strong>:
                              {{ setStatus(bookObj.status) }}
                              <small v-if="userId && bookObj.status === 15">(Aguardando Aprovação!)</small>
                              <small v-if="!userId && bookObj.status === 15">

                                 <!-- Botão para aprovar as datas de alteração de reserva -->
                                 <el-button
                                    class="mt-1 font-strong ml-3"
                                    type="warning"
                                    size="mini"
                                    @click='() => {
                             helpModal.open = true
                             helpModal.title = `Alteração nas datas da reserva nº ${bookObj.orderN}`
                             helpModal.desc =  `
                                   Caro(a) ${userName}, o ciclista solicitou uma alteração nas datas de checkin e checkout para esta reserva. Você não é obrigado a aceita-las, porém, caso não as aceite, este pedido será cancelado e o ciclista receberá o estorno por este pedido. Confira os detalhes da solicitação abaixo:<br/><br/>
                                   <ul class="text-left">
                                      <li><strong>Nova data para buscar (Checkin):</strong> ${ checkinDateChanged.formatedDate }</li>
                                      <li><strong>Nova data para entregar (Checkout):</strong> ${ checkoutDateChanged.formatedDate }</li>
                                      <li><strong>Novo total de diárias: </strong> ${ dailyNumber }</li>
                                      <li><strong>Valor da diária na hora da solicitação: </strong> ${ currentFormattedDailyValue }</li>
                                      <li><strong>Total da nova reserva + taxas: </strong> ${ totalOrderUpdatedFormated }</li>
                                      <li><strong>Total do pedido original: </strong> ${ totalOrderFormated }</li>
                                    </ul>
                                      <hr>
                                    <ul class="list-unstyled">
                                      <li>
                                        <strong>Valor do novo pedido:
                                             <h5>${ totalOrderUpdatedFormated }</h5>
                                        </strong>
                                        ${totalOrderValueUpdatedFormated.info}
                                      </li>
                                   </ul>`
                             helpModal.button.text = `Ok, aprovar novas datas`
                             helpModal.button.action = () => changeStatus(16, bookObj._id)
                             helpModal.cancel.text = `Reprovar Alterações`
                             helpModal.cancel.action = () => changeStatus(17, bookObj._id, `Alteração de Datas Reprovadas pelo Anfitrião`)
                       }'
                                 >
                                    Ver Datas e Aprovar
                                 </el-button>
                              </small>
                           </b-list-group-item>
                           <b-list-group-item v-if="userId">
                             <strong>Anfitrião</strong>: {{ bookObj.owner.firstName }}
                               {{ bookObj.owner.lastName }}
                           </b-list-group-item>

                           <b-list-group-item v-else>
                             <strong>Ciclista</strong>: {{ bookObj.customer.firstName }}
                             {{ bookObj.customer.lastName }}
                           </b-list-group-item>

                           <b-list-group-item>
                              <strong>Bicicleta</strong>: {{ bookObj.bike.name }}
                           </b-list-group-item>

                           <b-list-group-item>
                              <el-popover
                                 placement="top-start"
                                 title="AVISO!"
                                 width="200"
                                 trigger="hover"
                                 :content='userId ? `Caso não haja a devolução da bicicleta até o dia ${ formatDate(bookObj.period.checkout) } às 10:00, será cobrado este valor + taxas` : `Esse é o valor que você poderá cobrar do ciclista, caso ele não devolva a bicicleta.`'>
                                 <span slot="reference"><strong>Valor da Bicicleta</strong>:  {{ bookObj.bike.bikeValue | currency }} <i class="el-icon-warning-outline"></i> </span>
                              </el-popover>
                           </b-list-group-item>

                           <!-- Modalidade -->
                           <b-list-group-item  v-if="bookObj.typeOfLeasePeriod">
                                 <strong>Modalidade</strong>: {{ handleLeaseModality(bookObj.leaseModality) }} / {{ handleTypeOfLease(bookObj.typeOfLeasePeriod) }}
                           </b-list-group-item>

                           <b-list-group-item  v-if="!bookObj.typeOfLeasePeriod">
                              <strong>Modalidade</strong>: Sob-demanda / dia
                           </b-list-group-item>

                           <!-- Modalidade diária -->
                           <b-list-group-item
                              v-if="bookObj.typeOfLeasePeriod === 'daily' || !bookObj.typeOfLeasePeriod"
                              :class="{changed : dailyNumber > 0}"
                           ><strong>Período:</strong>
                               de
                               <span v-if="selectDatesQuery.dateCheckin">
                                  {{ selectDatesQuery.dateCheckin | moment("utc", "DD/MM/YY") }} <strong>até</strong>
                                 {{ selectDatesQuery.dateCheckout | moment("utc", "DD/MM/YY") }}
                               </span>

                                 <span v-else>
                                {{ bookObj.period.checkin | moment("utc", "DD/MM/YY") }} até
                                 {{ bookObj.period.checkout | moment("utc", "DD/MM/YY") }}
                               </span>

                           </b-list-group-item>

                           <!-- Período -->
                           <b-list-group-item>

                              <!-- Hora -->
                              <div v-if="bookObj.typeOfLeasePeriod === 'perHour'">
                                 <strong>Período</strong>:
                                 {{bookObj.daySelectedForHourlyRental | moment("utc", "DD/MM/YY") }}, das {{bookObj.startHourRental | moment("utc", "HH:mm") }} até {{bookObj.endHourRental | moment("utc", "HH:mm") }}
                              </div>

                              <!-- Diária -->
                              <div v-if="bookObj.typeOfLeasePeriod === 'daily' || !bookObj.typeOfLeasePeriod">
                                 <strong>Diárias</strong>: {{ dailyNumber > 0 && userId ? dailyNumber : bookObj.daily }}
                              </div>

                              <!-- Semana -->
                              <div v-if="bookObj.typeOfLeasePeriod === 'perWeek'">
                                 <strong>Período</strong>: {{ bookObj.numberOfRentalWeeks}} {{ bookObj.numberOfRentalWeeks > 1 ? 'semanas' : 'semana' }}
                              </div>

                              <!-- Mês -->
                              <div v-if="bookObj.typeOfLeasePeriod === 'monthly'">
                                 <strong>Período</strong>: {{ bookObj.numberOfMonthsOfLease}} {{ bookObj.numberOfMonthsOfLease > 1 ? 'meses' : 'mês' }}
                              </div>

                           </b-list-group-item>

                           <b-list-group-item v-if="bookObj.typeOfLeasePeriod === 'perHour'">
                              <strong>Quantidade de horas</strong>: {{timeNumber(bookObj.startHourRental, bookObj.endHourRental)}} {{timeNumber(bookObj.startHourRental, bookObj.endHourRental) > 1 ? 'horas' : 'hora'}}
                           </b-list-group-item>

                           <!-- Valor por período -->
                           <b-list-group-item>
                              <!-- Hora -->
                              <div v-if="bookObj.typeOfLeasePeriod === 'perHour'">
                                 <strong>Valor por hora</strong>: {{bookObj.bike.timeValue  | currency}}
                              </div>

                              <!-- Dia -->
                              <div
                                 v-if="bookObj.typeOfLeasePeriod === 'daily' || !bookObj.typeOfLeasePeriod"
                                 :class="{changed : dailyNumber > 0 && bike.dailyValue !== bookObj.bike.dailyValue}"
                              >
                                 <div v-if="dailyNumber > 0 && bike.dailyValue !== bookObj.bike.dailyValue && userId">
                                    <div class="daily-value-item-info-book">
                                       <strong>Valor da diária</strong>:
                                       {{bike.dailyValue | currency}}
                                       <el-popover
                                          placement="top"
                                          title="O valor da diária desta bike mudou!"
                                          width="200"
                                          trigger="click"
                                          content="ATENÇÃO: O valor atual da diária desta bike não é mais o mesmo de quando você fez a reserva. Se você solicitar alteração nas datas desta reserva, o valor total do pedido será atualizado com base no valor da diária atual da bike!">
                                          <el-button
                                             slot="reference"
                                             class="help-input-icon"
                                             icon="el-icon-info" circle></el-button>
                                       </el-popover>
                                    </div>
                                 </div>

                                 <div v-else>
                                    <strong>Valor da Diária</strong>: {{ bookObj.bike.dailyValue | currency }}
                                 </div>
                              </div>


                              <!-- Semana -->
                              <div v-if="bookObj.typeOfLeasePeriod === 'perWeek'">
                                 <strong>Valor por semana</strong>: {{ bookObj.bike.weekValue | currency}}
                              </div>

                              <!-- Mês -->
                              <div v-if="bookObj.typeOfLeasePeriod === 'monthly'">
                                 <strong>Valor mês</strong>: {{ bookObj.bike.monthValue | currency}}
                              </div>
                           </b-list-group-item>

                           <!-- Informações sobre taxa - desativado -->
                           <b-list-group-item v-if="false">Taxa da Operadora de Cartão

                              <el-tooltip class="item" effect="dark" content="Esse valor é a taxa que a operadora do cartão de crédito cobra por cada transação." placement="top">
                                 <v-icon style="margin-top: -3px;" class="text-muted ml-2" name="question-circle"
                                         scale="0.7"></v-icon>
                              </el-tooltip>
                              <span>
                        {{ ( (bookObj.daily * bookObj.bike.dailyValue) * rate() / 100 ) | currency }}</span></b-list-group-item>

                           <!-- Valor total do pedido -->
                           <b-list-group-item
                              :class="{changed : dailyNumber > 0 && userId && totalOrderUpdated !== ( bookObj.daily * bookObj.bike.dailyValue + bookObj.rate )}"
                              variant="primary"
                           >
                              <strong class="h6 font-weight-bold">Total do pedido:
                                 <span v-if="dailyNumber > 0 && userId">{{ totalOrderUpdated | currency }}</span>
                                 <span v-else>{{ bookObj.amount | currency }}</span>
                              </strong>
                              <div v-if="bookObj.status === 1">
                                 <span v-if="this.userId && bookObj.status === 1" class="">
                                    <i class="el-icon-info text-blue"></i> Combine com o anfitrião a forma de pagamento.
                                 </span>
                                 <span v-if="!this.userId && bookObj.status === 1" class="">
                                    <i class="el-icon-info text-blue"></i> Combine com o ciclista a forma de pagamento.
                                 </span>
                              </div>
                           </b-list-group-item>
                       </b-list-group>

                      <!-- Faz o checkin do pedido! -->
                      <el-button
                         :title=" activeCheckin ? 'Efetuar o Checkin' : 'Somente após a ' +  checkinDate "
                         v-if="(bookObj.status === 6) && !userId"
                         @click="() => {
                            helpModal.open = true
                            helpModal.title = 'Efetuar o checkin'
                            helpModal.desc = 'Você está prestes a efetuar o checkin deste pedido. Isso quer dizer que o ciclista veio buscar a bike no local indicado.'
                            helpModal.button.text = 'Ok, Efetuar o checkin!'
                            helpModal.button.action = () => checkinCheckout(bookObj.bike._id, bookObj._id, 7)
                            helpModal.button.type = 'blue'
                          }"
                         :loading="loading.status.checking"
                         type="blue"
                         class="mt-3"
                         style="width: 100%">
                         <strong>Efetuar o checkin</strong> (o ciclista buscou a bike)
                      </el-button>

                      <!-- Faz o checkout do pedido! -->
                      <el-button
                         :title=" activeCheckout ? 'Efetuar o Checkout' : 'Somente após a ' +  checkoutDate "
                         v-if="(bookObj.status === 7 || lateStatusList.includes(bookObj.status)) && !userId"
                         @click="() => {
                      helpModal.open = true
                      helpModal.title = 'Efetuar o checkout!'
                      helpModal.desc = 'Você está prestes a efetuar o checkout deste pedido. Isso quer dizer que o ciclista entregou a bike.'
                      helpModal.button.text = 'Ok, Efetuar o checkout!'
                      helpModal.button.action = () => checkinCheckout(bookObj.bike._id, bookObj._id, 8)
                      helpModal.button.type = 'primary'
                    }"
                         :loading="loading.status.checking"
                         class="mt-3"
                         type="primary"
                         style="width: 100%">
                         <strong>Efetuar o checkout</strong> (o ciclista entregou a bike)
                      </el-button>

                      <!-- Botão Avaliação -->
                      <div v-if="!userId && bookObj.status === 8">
                       <span v-if="!bookObj.resources.ownerRating">
                         <el-button
                            @click="openRating(bookObj)"
                            icon="el-icon-star-off"
                            type="rating"
                            class="font-weight-bold mt-3"
                            style="width: 100%">
                             Avalie o Ciclista {{this.bookObj.customer.firstName + ' ' + this.bookObj.customer.lastName}} ref. a essa reserva.
                           </el-button>
                        </span>

                         <span v-else>
                        <el-button
                           icon="el-icon-star-on"
                           type="success"
                           plain
                           class="font-weight-bold mt-3"
                           style="width: 100%">
                             Você já avaliou esse ciclista ref. a essa reserva!
                           </el-button>
                       </span>
                      </div>

                      <!-- Abre a Gaveta do Chat -->
                      <div>

                         <el-button
                            v-if="(bookObj.status !== 8 && bookObj.status !== 14 && bookObj.status !== 12)"
                            @click="openChat(bookObj)"
                            icon="el-icon-chat-line-square"
                            type="secondary"
                            class="mt-3"
                            style="width: 100%">
                            {{bookObj.status === 1 ? 'Combinar pagamento com ' : 'Falar com'}}
                            {{!this.userId ? this.bookObj.customer.firstName + ' ' + this.bookObj.customer.lastName : this.bookObj.owner.firstName + ' ' + this.bookObj.owner.lastName}}
                         </el-button>
                      </div>

                      <!-- Aprovar e Rejeitar a Reserva -->
                      <el-row :gutter="30">

                         <!-- Aprovar a Reserva -->
                         <el-col v-if="(bookObj.status === 1) && !userId" :xs="24" :lg="12">
                            <el-button
                               @click="approveReservation.infoModal = true"
                               :disabled="approveReservation.btnStatus"
                               icon="el-icon-check"
                               type="primary"
                               class="mt-3"
                               size="lg"
                               style="width: 100%">
                               <strong>Aprovar Reserva</strong>
                            </el-button>
                         </el-col>

                         <!-- Rejeitar a Reserva -->
                         <el-col
                            v-if="userId || activeAproveReproveButton"
                            :xs="24"
                            :lg="!userId && bookObj.status === 1
                            ? 12 : 24">
                            <el-button
                               v-if="[1, 2, 6].includes(bookObj.status)"
                               @click="rejectReservation.infoModal = true"
                               :disabled="approveReservation.btnStatus"
                               icon="el-icon-close"
                               type="danger"
                               plain
                               class="mt-3"
                               style="width: 100%">
                               <strong>{{userId ? 'Cancelar Reserva' : 'Rejeitar Reserva'}}</strong>
                            </el-button>
                         </el-col>
                      </el-row>

                   </el-card>

                  <el-alert
                    v-if="bookObj.status === 15"
                    class="mt-2"
                    :title="!userId && bookObj.status === 15 ?
                     'ATENÇÃO: Caso você não aprove as novas datas de reserva, este pedido será automaticamente cancelado.' :
                     'ATENÇÃO: Caso o anfitrião não aprove as novas datas de reserva, este pedido será automaticamente cancelado.' "
                    type="warning"
                    effect="dark">
                  </el-alert>

                   </b-col>

                   <!-- Cartão do ciclista -->
                   <b-col order-lg="3" cols="12" lg="4" class="mt-4 mt-lg-0">
                      <h5 v-if="this.userId">Cartão do anfitrião</h5>
                      <h5 v-else>Cartão do ciclista</h5>
                      <UserVerificationCard
                         :userType="this.userId ? 'anfitrião' : 'ciclista'"
                         :userId="this.userId || this.bookObj.customer._id"
                      />

                      <!-- Report Problem Action / Ação para Reportar um Problema -->
                      <el-button
                         @click="reportProblemAction(1)"
                         icon="el-icon-message"
                         class="mt-4"
                         type="default"
                         style="width: 100%">
                         Relatar um Problema
                      </el-button>
                   </b-col>

                  <!-- Timeline / Linha do tempo -->
                  <b-col order-lg="1" cols="12" lg="3" class="mt-4 mt-lg-0 d-none d-lg-block">
                     <h5 class="mb-3">Logs - Linha do Tempo</h5>
                     <el-card :class="`box-card`">
                        <div class="timeline-wrap">
                        <el-timeline :reverse="true" v-if="activities.length" class="p-0">
                           <el-timeline-item
                              v-for="(activity, index) in activities"
                              :key="index"
                              :timestamp="activity.timestamp"
                              :icon="activity.icon"
                              :type="activity.type"
                              :color="activity.color"
                              size="large"
                              placement="top"
                           >
                              <el-card>
                                 <span class="font-weight-bold" :class="[{'text-danger': activity.type === 'danger'}, {'text-info': activity.type === 'info'}, {'text-success': activity.type === 'success'}]">
                                     {{ activity.content }}
                                 </span>
                                 <div class="text-muted small"> {{ activity.obs }}</div>
                              </el-card>
                           </el-timeline-item>
                        </el-timeline>
                     </div>
                     </el-card>
                  </b-col>

               </b-row>
           </b-container>

               <hr>

               <div class="text-center mt-4 btn-booking-actions">
                  <div class="d-inline-block" v-if="bookObj.resources && bookObj.resources.additionalCharge !== undefined">

                     <!-- Botão cobrar valor da bike e input de valor personalizado -->
                     <div class="d-inline-block"  v-if="!brokenCharging.length && !firstBrokenCharging || brokenChargingValueComplete">
                        <el-button
                           v-if="( lateStatusList.includes(bookObj.status)  && !userId && bookObj.resources.additionalCharge !== undefined && bookObj.resources.additionalCharge.length > 1)"
                           @click="chargeNewDaily(bookObj._id, 'BIKE_COMPLETE_CHARGE')"
                           :disabled="approveReservation.chargeNewDaily || brokenChargingValueComplete"
                           :loading="loading.chargeNewDaily"
                           type="blue"
                           class="mb-3"
                           style="margin-left: 16px;">
                           {{bike_complete_charging.length && bike_complete_charging[0].type === 'BIKE_COMPLETE_CHARGING' || brokenChargingValueComplete ? 'Você já cobrou o valor integral da bicicleta' : `Cobrar Valor da Bike`}} ({{bookObj.bike.bikeValue | currency}})

                        </el-button>
                     </div>

                     <div v-if="!brokenChargingValueComplete">

                        <el-form
                           v-if="firstBrokenCharging ||  brokenCharging.length"
                           :inline="true"
                           class="form-brokenCharging mb-3 mb-lg-0"
                           :model="formBrokenCharging"
                           ref="formBroken"
                           :rules="formBrokenChargingRules"
                           @keyup.enter.native="chargeBroken(bookObj._id, 'BROKEN_CHARGING')"
                        >
                           <el-form-item class="mb-0" label="">
                              <el-popover
                                 placement="top-start"
                                 title="Ajuda"
                                 trigger="hover"
                                 content="Experimente cobrar valores menores e em várias etapas. Máximo R$ 100,00 por tentativa.">
                                 <el-button size="small" icon="el-icon-question" slot="reference"></el-button>
                              </el-popover>
                           </el-form-item>
                           <el-form-item class="mb-0" label="" style="width: 110px" prop="amount">
                              <money
                                 :class="'fake-input'"
                                 v-model="formBrokenCharging.amount"
                                 v-bind="money"
                                 @keyup.enter.native="chargeBroken(bookObj._id, 'BROKEN_CHARGING')"
                              >
                              </money>
                           </el-form-item>
                           <el-form-item>
                              <el-button
                                 :loading="loading.chargeNewDaily"
                                 size="small" class="mb-0" type="primary" @click="chargeBroken(bookObj._id, 'BROKEN_CHARGING')">Cobrar</el-button>
                           </el-form-item>
                        </el-form>

                     </div>
                  </div>

                  <div class="d-inline-block">

                     <!-- Botão cobrar nova diária -->
                     <el-button
                        v-if="lateStatusList.includes(bookObj.status) && !userId && !additionalDailyCharges"
                        @click="chargeNewDaily(bookObj._id)"
                        :disabled="approveReservation.chargeNewDaily || !activeAdditionalDaily"
                        :loading="loading.chargeNewDaily"
                        type="blue"
                        class="mb-3"
                        style="margin-left: 16px;">
                        Cobrar Diária Adicional {{!activeAdditionalDaily ? '(a partir de amanhã)' : ''}}
                     </el-button>

                     <div class="d-inline-block"  v-if="userId && bookObj.status === 8">
                          <span v-if="!bookObj.resources.customerRating">
                             <el-button
                                @click="openRating(bookObj)"
                                icon="el-icon-star-off"
                                type="rating"
                                class="mb-3 font-weight-bold"
                                style="margin-left: 16px;">
                                 O que achou desta reserva? Faça uma avaliação
                              </el-button>
                          </span>
                         <span v-else>
                            <el-button
                               icon="el-icon-star-on"
                               type="success"
                               plain
                               class="mb-3 font-weight-bold"
                               style="margin-left: 16px;">
                              Você já avaliou essa reserva!
                           </el-button>
                         </span>
                     </div>

                      <!--  Open Reject Reservation Info Modal / Abre o Modal de Informações para Rejeitar a Reserva -->
                      <el-button
                          v-if="(bookObj.status === 5) && !userId"
                          @click="rejectReservation.infoModal = true"
                          :disabled="rejectReservation.btnStatus"
                          icon="el-icon-close"
                          class="mb-3"
                          type="danger"
                          style="margin-left: 16px;">
                          Rejeitar
                      </el-button>

                  </div>

               </div>

           <b-container fluid>
              <b-row class="d-block d-lg-none">
                 <!-- Timeline / Linha do tempo -->
                 <b-col order-lg="1" cols="12" lg="3" class="mt-4 mt-lg-0">
                    <h6 class="mb-3">Logs - Linha do Tempo</h6>
                    <div class="timeline-wrap">
                       <el-timeline :reverse="true" v-if="activities.length" class="p-0">
                          <el-timeline-item
                             v-for="(activity, index) in activities"
                             :key="index"
                             :timestamp="activity.timestamp"
                             :icon="activity.icon"
                             :type="activity.type"
                             :color="activity.color"
                             size="large"
                             placement="top"
                          >
                             <el-card>
                                 <span class="font-weight-bold" :class="[{'text-danger': activity.type === 'danger'}, {'text-info': activity.type === 'info'}, {'text-success': activity.type === 'success'}]">
                                     {{ activity.content }}
                                 </span>
                                <div class="text-muted small"> {{ activity.obs }}</div>
                             </el-card>
                          </el-timeline-item>
                       </el-timeline>
                    </div>
                 </b-col>
              </b-row>
           </b-container>

               <!--=== Approve Reservation Info Modal / Modal de Informações para Aprovar a Reserva ===-->
               <el-dialog
                   center
                   class="modal-book inner-modal"
                   :visible.sync="approveReservation.infoModal"
                   :before-close="leaveReservationApproval"
                   append-to-body>

                   <!-- Modal Contents / Conteúdo do Modal -->
                   <div class="text-center">
                       <v-icon class="text-primary mb-3" scale="2" name="exclamation-circle"></v-icon>
                       <h4>Aprovar Reserva #{{bookObj.orderN}}</h4>
                       <p class="text-muted">Após a sua aprovação, o ciclista será comunicado sobre o local para buscar e entregar a sua bicicleta. Certifique-se de que a sua bike esteja em perfeito estado.</p>
                   </div>

                   <!-- Action to Approve Reservation / Ação para Aprovar a Reserva -->
                   <div class="text-center mt-4">

                       <el-button
                           v-if="bookObj.status === 1"
                           @click="approveOrder(bookObj._id)"
                           :loading="approveReservation.btnLoading"
                           type="primary"
                           :hidden="approveReservation.hidden"
                       >Ok, já combinei o pagamento e quero <b>Confirmar Reserva</b>
                       </el-button>

                     <el-button
                       v-if="bookObj.status === 3"
                       @click="changeStatus(6, bookObj._id)"
                       :loading="approveReservation.btnLoading"
                       type="primary"
                     >Tentar Novamente
                     </el-button>
                   </div>
               </el-dialog>

               <!--=== Approve Reservation Success Info / Modal de Confirmação da Aprovação da Reserva ===-->
               <el-dialog
                   center
                   class="modal-book inner-modal"
                   :visible.sync="approveReservation.confirmationModal"
                   append-to-body>

                   <!-- Modal Contents / Conteúdo do Modal -->
                   <div class="text-center">
                       <v-icon class="text-primary mb-3" scale="2" name="check-circle"></v-icon>
                       <h4 class="mb-4">Reserva Confirmada com Sucesso</h4>
                       <p class="text-muted">A reserva da bicicleta "Bicicleta Aro 29 Legends 2019" para o Ciclista João
                           Carlos, com
                           Buscar no dia 23/11/2019 e Entregar no dia 25/11/2019, foi confirmada com sucesso!</p>
                       <p>
                           <v-icon class="text-info mr-2" name="info-circle"></v-icon>
                           <strong>Lembre-se de levar a sua bike no local indicado, com pelo menos 15min de
                               antecedencia!</strong></p>
                   </div>

                   <!-- Action Ok en Close Success Modal / Ação para Fechar o Modal de Sucesso. -->
                   <div class="text-center mt-4">
                       <el-button
                           icon="el-icon-check"
                           type="primary"
                           @click="approveReservation.confirmationModal = false">
                           Ok, Obrigado(a)
                       </el-button>
                   </div>
               </el-dialog>

               <!--=== Reject Reservation Info Modal / Abre o Modal de Informações para Aprovar a Reserva /  Modal de Informações para Rejeitar a Reserva ===-->
               <el-dialog
                  top="5vh"
                   center
                   class="modal-book inner-modal"
                   :visible.sync="rejectReservation.infoModal"
                   :before-close="leave_RejectReservation"
                   append-to-body
                   :close-on-click-modal="false"
               >

                   <!-- Modal Contents / Conteúdo do Modal -->
                   <div class="text-center">
                       <v-icon class="text-danger mb-3" scale="2" name="exclamation-circle"></v-icon>
                       <h4 class="text-danger">{{userId ? 'Cancelar Reserva' : 'Rejeitar Reserva'}}</h4>
                       <p class="font-weight-bold" v-if="userId">Atenção! Você está prestes a cancelar a sua reserva.</p>
                       <p class="font-weight-bold" v-else>Atenção! Você está prestes a rejeitar a reserva.</p>

                     <div v-if="userId">
                       <p class="text-muted">Após o seu cancelamento, o anfitrião será comunicado e informado sobre o motivo de sua reserva ter sido cancelada.</p>
                     </div>

                     <div v-else>

                       <p class="text-muted">Após a sua rejeição, o ciclista será comunicado e informado sobre o motivo de sua reserva ter sido cancelada.</p>
                     </div>

                       <!-- form to submit reason for rejection / Formulário para enviar o motivo da rejeição -->
                       <el-form
                         ref="formReason"
                         :model="formReason"
                         :rules="formReasonRules"
                       >
                           <el-form-item prop="reason">
                               <el-select v-model="formReason.reason" placeholder="Selecione o motivo">
                                   <el-option
                                     v-for="(item, index) in rejectReason"
                                     :key="index"
                                     :label="item.label"
                                     :value="item.value"></el-option>
                               </el-select>
                           </el-form-item>
                           <el-form-item label="" prop="desc">
                               <el-input
                                   placeholder="Descreva o motivo..."
                                   :rows="2"
                                   maxlength="150"
                                   show-word-limit
                                   type="textarea" v-model="formReason.desc"></el-input>
                           </el-form-item>
                       </el-form>
                   </div>

                   <!-- Action to Reject Reservation / Ação para Rejeitar a Reserva -->
                   <div class="text-center mt-4">
                       <el-button
                           @click="_rejectReservation('formReason')"
                           :loading="rejectReservation.btnLoading"
                           type="danger">
                         {{userId ? 'Ok, Cancelar Reserva' : 'Ok, Rejeitar Reserva'}}

                       </el-button>
                   </div>
               </el-dialog>

               <!--=== Reject Reservation Success Info / Modal de Confirmação da Rejeição da Reserva ===-->
               <el-dialog
                   center
                   class="modal-book inner-modal"
                   :visible.sync="rejectReservation.confirmationModal"
                   append-to-body>

                   <!-- Modal Contents / Conteúdo do Modal -->
                   <div class="text-center">
                       <v-icon class="text-danger mb-3" scale="2" name="check-circle"></v-icon>
                       <h4 class="mb-4 text-danger">{{userId ? 'A Reserva foi Cancelada' : 'A Reserva foi Rejeitada'}}</h4>
                     <p v-if="userId" class="text-muted">A reserva #{{bookObj.orderN}} - {{bookObj.bike.name}} do anfitrião {{userName}}, foi cancelada e o mesmo já foi notificado!</p>
                       <p class="text-muted">A reserva #{{bookObj.orderN}} - {{bookObj.bike.name}} para o ciclista {{userName}}, foi rejeitada e o mesmo já foi notificado!</p>
                   </div>

                   <!-- Action Ok en Close Success Modal / Ação para Fechar o Modal de Sucesso. -->
                   <div class="text-center mt-4">
                       <el-button
                           @click="rejectReservation.confirmationModal = false"
                           type="primary">
                           Ok, Obrigado(a)
                       </el-button>
                   </div>
               </el-dialog>

             <!--=== Help Modal ===-->
             <el-dialog
               center
               top="5vh"
               class="modal-book inner-modal"
               :visible.sync="helpModal.open"
               append-to-body
               :before-close="closeHelpModal"
             >
               <!-- Modal Contents / Conteúdo do Modal -->
               <div class="text-center">
                 <h4 class="mb-4">{{helpModal.title}}</h4>
                 <p class="mb-0 text-muted"><span v-html="helpModal.desc"></span></p>
               </div>

               <!-- Action Ok en Close Success Modal / Ação para Fechar o Modal de Sucesso. -->
               <div class="text-center mt-4">
                 <el-button
                    :disabled="helpModal.button.disabled"
                   :hidden="helpModal.button.hidden"
                   :loading="helpModal.button.state"
                   @click="helpModal.button.action()"
                   :type="helpModal.button.type">
                   {{ helpModal.button.text }}
                 </el-button>
                 <el-button
                    :disabled="helpModal.cancel.disabled"
                   :hidden="helpModal.cancel.hidden"
                   :loading="helpModal.cancel.state"
                   @click="helpModal.cancel.action()"
                   type="info">
                   {{ helpModal.cancel.text }}
                 </el-button>
               </div>
             </el-dialog>
        </el-dialog>

          <!--=== Chat Drawer / Gaveta do Chat ===-->
       <el-drawer
          custom-class="chat-pedale"
          :title="`Chat com ${  userId ? bookObj.owner.firstName + ' ' + bookObj.owner.lastName : bookObj.customer.firstName  + ' ' + bookObj.customer.lastName} - Pedido #${bookObj.orderN}`"
          :visible.sync="chat.open"
          :before-close="closeChat"
       >
          <div v-if="chat.open" class="h-100">
             <Chat class="h-100" :bookObj="bookObj" :userId="userId"></Chat>
          </div>

       </el-drawer>

       <!--=== Modal Avaliação ===-->
       <el-dialog
          top="5vh"
          center
          class="modal-book inner-modal"
          :visible.sync="rating.modal"
          :before-close="leave_RejectRating"
          append-to-body
          :close-on-click-modal="false"
       >

          <!-- Modal Contents / Conteúdo do Modal -->
          <div class="text-center">
             <h1 style="line-height: 0" class="text-rating mt-0 mb-1 pt-0"><i class="el-icon-star-off"></i></h1>
             <h4 class="text-rating"> {{userId ? 'Avaliar Reserva' : 'Avaliar Ciclista'}}</h4>


             <h6 v-if="userId" class="mt-4 mb-4 text-rating">{{this.bookObj.customer.firstName}}, o que você achou desta reserva? Faça uma avaliação, com uma nota de 1 a 5 estrelas:
             </h6>

             <h6 v-else class="mt-4 mb-4 text-rating">{{this.bookObj.owner.firstName}}, o que você achou deste ciclista? Faça uma avaliação, com uma nota de 1 a 5 estrelas:
             </h6>

             <el-rate
                class="btn-rate"
                v-model="formRating.rate"
                :texts="['Muito Insatisfeito(a)', 'Insatisfeito(a)', 'Agradável', 'Satisfeito(a)', 'Muito Satisfeito(a)']"
                show-text>
             </el-rate>

             <p class="text-danger" v-if="rating.error">Por favor, selecione de uma a cinco estrelas para esta avaliação.</p>

             <p v-if="userId" class="mt-4">Deixe um comentário para que os outros ciclistas possam saber previamente como será a experiência de pedalada com esta bike e o relacionamento com o anfitrião.</p>

             <p v-else class="mt-4">Deixe um comentário para que os outros anfitriões possam saber previamente como será a experiência de relacionamento com este ciclista:</p>

             <el-form
                ref="formRating"
                :model="formRating"
                :rules="formRatingRules"
             >
                <el-form-item label="" prop="comment">
                   <el-input
                      placeholder="Escreva o seu comentário..."
                      :rows="3"
                      maxlength="1024"
                      show-word-limit
                      type="textarea" v-model="formRating.comment"></el-input>
                </el-form-item>
             </el-form>
             <!-- Action to Reject Reservation / Ação para Rejeitar a Reserva -->
             <div class="text-center mt-4">
                <el-button
                   @click="sendRating('formRating')"
                   :loading="rating.loading"
                   type="rating">
                   Enviar Avaliação
                </el-button>
             </div>
          </div>
       </el-dialog>

    </div>
</template>

<script>
import Chat from "@/components/Chat";
import { config } from "@/config";
import { setStatus, statusColor } from "@/helpers/status";
import BikeService from "@/services/bike.service";
import OrderService from "@/services/order.service";
import UserService from "@/services/user.service";
import numeral from "numeral";
import { Money, VMoney } from 'v-money';
// eslint-disable-next-line no-unused-vars
import UserVerificationCard from "@/components/UserVerificationCardV2";
import { calcAmountOrder, dailyNumber } from "@/helpers";
import { BListGroup, BListGroupItem } from "bootstrap-vue";
import { handleLeaseModality, handleTypeOfLease, timeNumber } from "../../../helpers";
export default {
   name: 'Books',
   components: {
      Money,
      Chat,
      UserVerificationCard,
      BListGroup,
      BListGroupItem
    },
   directives: {
       money: VMoney,
      'b-list-group': BListGroup,
      'b-list-group-item': BListGroupItem
   },
    props: {
        userId: {
          type: String,
          default: '',
        },
        pageTitle: null,
    },
    data() {
        return {
            timestamp: "",
            tableReservationData: [],
            search: '',
            filterStatusData: [
               {text: 'Aguardando Aprovação', value: 1},
                {text: 'Pagamento Concluído', value: 2},
                {text: 'Pagamento Recusado', value: 3},
                {text: 'Pagamento Estornado', value: 4},
                {text: 'Aguardando Checkin', value: 6},
                {text: 'Em Vigor', value: 7},
                {text: 'Concluído', value: 8},
                {text: 'Atrasado!', value: 9},
                {text: 'Reportado pelo Anfitrião', value: 10},
                {text: 'Reportado pelo Ciclista', value: 11},
                {text: 'Cancelado - Você Recusou o Pedido!', value: 12},
                {text: 'Cancelado pelo Ciclista', value: 13},
                {text: 'Cancelado pelo Sistema', value: 14},
            ],
            booking: {
                bookingDetailsModal: false,
                data: ''
            },
            approveReservation: {
                infoModal: false,
                confirmationModal: false,
                btnStatus: false,
                btnLoading: false,
                hidden: false,
                chargeNewDaily: false,
                chargeBikeValue: false
            },
            rejectReservation: {
                infoModal: false,
                confirmationModal: false,
                btnStatus: false,
                btnLoading: false,
                hidden: false
            },
            rejectReason: [
                {label: "Imprevisto", value: "Imprevisto"},
                {label: "Força Maior", value: "Força Maior"},
                {label: "Outros", value: "Outros"}
            ],
            chatObj: [
                {
                    id: 1,
                    user: 'Pedro Henrique',
                    client: true,
                    date: ' 21/11/2019 às 10:45',
                    text: 'Olá, gostaria de saber se eu posso retirar a bicicleta as 13h na frente da prefeitura da cidade? Aguardo sua confirmação.'
                },
                {
                    id: 2,
                    user: 'Joao Carlos',
                    client: false,
                    date: ' 22/11/2019 às 13:22',
                    text: 'As 13h eu não vou conseguir, porém as 14:30 eu consigo. Pode ser?'
                },
                {
                    id: 3,
                    user: 'Pedro Henrique',
                    client: true,
                    date: '21/11/2019 às 23:12',
                    text: 'Ok então, combinado 👍 😉'
                },

            ],
            formReason: {
                reason: '',
                desc: ''
            },
            formReasonRules: {
              reason: [
                {required: true, message: 'Por favor, selecione o motivo', trigger: 'blur'},
              ],
              desc: [
                {required: true, message: 'Descreva maiores detalhes sobre o motivo.', trigger: 'blur'},
                {
                  min: 10,
                  max: 150,
                  message: 'Você precisa digitar ao menos 10 caracteres.',
                  trigger: 'blur'
                }
              ],
          },
            activities: [],
            bookObj: {
                orderN: null,
                bike: {
                    _id:  null,
                    name: '',
                    location: {},
                    address: {},
                    features: {},
                    bikeType: '',
                    slug: '',
                    dailyValue: 0,
                   timeValue: 0,
                   weekValue: 0,
                   monthValue: 0,
                },
                customer: {},
                owner: {},
                createdAt: null,
                period: {
                    checkin: null,
                    checkout: null
                },
                status: null,
                daily: null,
                rate: null,
                resources: {
                   ownerRating: false,
                   customerRating: false
                },
            },
            approval: null,
            bookingDates: {
                dateCheckin: '2020-02-27',
                dateCheckout: '2020-10-19',
            },
            loading: {
                status: {
                    checking: false
                },
                books: false,
               chargeNewDaily: false,
               chat: false,
            },
            bikeView: false,
            logStatusTemp: null,
            setStatus,
            statusColor,
            pagination: {
                total: 0,
                page: 1,
                perPage: 10
            },
            now: new Date(),
            activeCheckout: true,
            activeCheckin: true,
            activeAdditionalDaily: false,
            helpModal: {
              open: false,
              title: '',
              desc: '',
              button: {
                state: false,
                text: '',
                action: null,
                hidden: false,
                disabled: false,
                type: 'primary'
              },
              cancel: {
                state: false,
                text: 'Cancelar',
                hidden: false,
                disabled: false,
                action: () => {
                  this.helpModal.open = false;
                  this.clearSelectDatesComponent()
                }
              }
            },
            changeDateTrigger: false,
            bike: {},
            tempBike: {},
            renderComponent: true,
            rate: () => this.isPJ ? config.pj.rates.serviceCostPercentage : config.pf.rates.serviceCostPercentage,
            openCalendar: false,
            newDates: null,
            additionalDailyCharges: false,
            bike_complete_charging: [],
            brokenCharging: [],
            firstBrokenCharging: false,
            formBrokenCharging: {
               amount: 0.00
            },
           formBrokenChargingRules: {
              amount: [
                 {required: true, validator: this.priceValidation, trigger: 'blur'}
              ],
           },
           money: {
              decimal: ',',
              thousands: '.',
              prefix: 'R$ ',
              precision: 2,
              masked: false /* doesn't work with directive */
           },
           brokenChargingValueComplete: false,
           lateStatusList: [9, 18, 19, 20, 21],
           changeDatesToday: false,
           changeDatesTomorrow: false,
           activeAproveReproveButton: true,
           chat: {
               open: false,
               bookObj: {}
           },
           rating: {
              modal: false,
              loading: false,
              error: false
           },
           formRating: {
              rate: null,
              comment: ''
           },
           formRatingRules: {
              rate: [
                 {required: true, message: 'Por favor, Selecione a sua avaliação', trigger: 'blur'},
              ],
              comment: [
                 {required: true, message: 'Por favor, escreva o seu comentário', trigger: 'blur'},
                 {
                    min: 5,
                    max: 1024,
                    message: 'Você precisa digitar ao menos 5 caracteres.',
                    trigger: 'blur'
                 }
              ],
           },
           textAboutRate: 'Esse é o valor que mantém a plataforma funcionando e viabiliza constantes melhorias.',
           userNivelData: {},
           searchQuery: '',
        }
    },

    async mounted() {
        await this.getOrders();
    },

    methods: {
       timeNumber,
       handleLeaseModality,
       handleTypeOfLease,

       changeState(response) {
          this.logStatusTemp = response.data.order.logs.status;
          this.bookObj.logs = response.data.order.logs;

          this.bookObj.period = response.data.order.period;
          this.bookObj.amount = response.data.order.amount;

          this.bookObj.daily = this.$moment(response.data.order.period.checkout).diff(response.data.order.period.checkin, 'days');

          this.loading.status.checking = false;
          this.helpModal.button.state = false
          this.helpModal.cancel.state = false
          this.helpModal.open = false;

          this.approveReservation.btnLoading = false;
          this.approveReservation.infoModal = false
       },

        isOpened(v) {
          this.openCalendar = v
        },

        async closeHelpModal() {
            await this.getOrders();
            this.helpModal.open = false
            this.helpModal.button.hidden = false
        },

        async getOrders() {
            this.loading.books = true
            const orders = await OrderService.getOrders(this.userId, this.pagination.perPage, this.pagination.page, this.searchQuery)

            if (orders) {
              this.pagination.total = orders.data.total;
              this.tableReservationData = orders.data.order;
              this.tableReservationData.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
              this.countNewOrders()

              this.loading.books = false
            }

        },

        changePage() {
          this.getOrders()
        },

        changeSize(v) {
          this.pagination.perPage = v
          this.getOrders()
        },

        viewOrder(id) {

          if (!this.userId) {
            const data = {
              orderId: id,
            }

            OrderService.viewOrder(data)
              .then((response) => {
                if (response) {
                  this.tableReservationData.map((v) => {
                    if (v._id === response.data.data._id) {
                      v.logs = response.data.data.logs
                    }
                  })
                  this.countNewOrders()
                }

              })
              .catch(err => {
                this.$message.error(err);
              });

          }


        },

        countNewOrders() {
            let checksNewOrders = 0;

            this.tableReservationData.map(v => {
                if (v.logs.viewed === undefined)
                    return checksNewOrders++
            });

            this.$store.dispatch('order/query', checksNewOrders);
        },

        leaveReservationApproval(done) {
            this.$confirm('Você tem certeza que deseja sair sem aprovar a reserva?')
                .then(() => {
                    this.approveReservation.hidden = false
                   this.helpModal.button.hidden = false
                    done();
                })
                .catch(() => {
                });
        },

        leave_RejectReservation(done) {
            this.$confirm('Você tem certeza que deseja sair sem rejeitar a reserva?')
                .then(() => {
                    this.approveReservation.hidden = false
                   this.helpModal.button.hidden = false
                    done();
                })
                .catch(() => {
                });
        },

        reportProblemAction(userID) {
            let user = {ID: userID, name: 'João Carlos'};
            location.href = 'mailto:ajuda@pedale.net.br?Subject=Ajuda%20Pedale%20-%20Cliente%20#' + user.ID + '%20-%20' + user.name + ''
        },

        async _rejectReservation(formName) {

          this.$refs[formName].validate(async (valid) => {

            this.rejectReservation.btnLoading = true;

            if (valid) {

              let info
               const obs = this.formReason.reason + ' - ' + this.formReason.desc
              let status = this.userId ? 13 : 12

               if (status === 12) {
                  info = "Cancelado pelo anfitrião"
               }

               if (status === 13) {
                  info = "Cancelado pelo ciclista"
               }

               await OrderService.cancelOrder(this.bookObj._id, status, info, obs)
                  .then((async (response) => {
                        this.rejectReservation.btnLoading = false;
                        this.$message.success(response.data.message);
                        this.rejectReservation.infoModal = false
                        this.changeState(response)
                  }
               )).catch(() => {
                     this.rejectReservation.btnLoading = false;
                  })

            } else {
              this.$message.warning('Por favor, preencha todos os campos corretamente!');
              this.rejectReservation.btnLoading = false;
              return false;
            }
          })

        },

        _approveReservation(id) {

            const data = {
                orderId: id,
                status: 6,
            }
            this.approveReservation.btnLoading = true;

            OrderService.statusOrder(data)
                .then((response) => {
                    if (response.data.data) {
                        this.$message.success("Pedido aprovado com sucesso!");
                        this.activities[2].content = "Pedido Aprovado";
                        this.activities[2].timestamp = this.$moment("utc", response.data.approval).format("DD-MM-YYYY [às] H:mm:ss");
                        this.activities[2].type = 'primary';
                        this.activities[2].icon = 'el-icon-success';
                        this.bookObj.status = response.data.data.status
                        this.bookObj.approval = response.data.data.approval
                        this.approveReservation.btnLoading = false;
                        this.approveReservation.infoModal = false
                    }
                })
                .catch(err => {
                    this.$message.error(err);
                });
        },

        async approveOrder(orderId) {
           try {
              this.approveReservation.btnLoading = true
              this.loading.status.checking = true;
              await OrderService.approveOrder(orderId).then((async (response) => {
              this.$message.success(response.data.message);
              this.changeState(response)
              }))
           } catch (e) {
              this.approveReservation.btnLoading = false
           }
        },

       async checkinCheckout(bikeId, orderId, status) {
          try {
             this.loading.status.checking = true;
             await OrderService.checkinCheckout(bikeId, orderId, status).then((async (response) => {
               this.$message.success(response.data.message);
               this.changeState(response)
             }))
          } catch (e) {
             new Error(e)
          }
       },

        async changeStatus(status, id, info) {

          try {
            const data = {
              orderId: id,
              status,
              info
            }

             /* Reserva Aprovada */
            if (status === 6) {
              this.approveReservation.btnLoading = true;
            }

             /* Rejeitado pelo Anunciante */
            if (status === 12) {

              data.info = 'Rejeitado/Cancelado pelo Anfitrião';
              data.obs = this.formReason.reason + ' - ' + this.formReason.desc;
              data.type = 'danger';

              this.rejectReservation.btnLoading = true;
              this.rejectReservation.infoModal = true;
            }

             /* Cancelado pelo Ciclista */
             if (status === 13) {

                data.info = 'Cancelado pelo Ciclista';
                data.type = 'danger';
                data.obs = this.formReason.reason + ' - ' + this.formReason.desc;

                this.rejectReservation.btnLoading = true;
                this.rejectReservation.infoModal = true;
             }

             /* Solicitação de Alteração de Datas */
            if (status === 15) {

               let checkin = new Date(this.checkinDateChanged.date)
               let checkout = new Date(this.checkoutDateChanged.date)

              this.helpModal.button.state = true
              this.helpModal.cancel.disabled = true


              data.info = 'Solicitação de Alteração de Datas'
              data.type = 'info'
              data.obs = `O ciclista solicitou uma alteração nas datas da reserva: Buscar: ${this.$moment(checkin).utc().format("DD-MM-YYYY")} -> Entregar ${this.$moment(checkout).utc().format("DD-MM-YYYY")}.`

              data.resources = {
                changeOfDates: {
                  checkin,
                  checkout,
                  dailyValue: this.bike.dailyValue
                }
              }
            }

             /* Alteração de datas aprovadas */
            if (status === 16) {
              this.helpModal.button.state = true
              this.helpModal.cancel.disabled = true

            }

            /* Reprovação de alteração de datas */
            if (status === 17) {
               this.helpModal.button.disabled = true
              this.helpModal.cancel.state = true
              data.type = 'danger';
            }

            this.loading.status.checking = true;

            await OrderService.statusOrder(data)
              .then(async (response) => {
                if (response.data.data) {
                  const status = response.data.data.status;
                  this.$message.success("Status do pedido alterado!");
                  this.logStatusTemp = response.data.data.logs.status;
                  this.bookObj.logs = response.data.data.logs;

                  this.bookObj.period = response.data.data.period;
                  this.bookObj.amount = response.data.data.amount;

                  this.bookObj.daily = this.$moment(response.data.data.period.checkout).diff(response.data.data.period.checkin, 'days');

                  this.loading.status.checking = false;
                  this.helpModal.button.state = false
                  this.helpModal.cancel.state = false
                  this.helpModal.open = false;

                  if (status === 6) {
                    this.approveReservation.btnLoading = false;
                    this.approveReservation.infoModal = false
                  }

                  if (status === 12) {
                    this.bookObj.status = 12
                  }

                  if (status === 13) {
                    this.bookObj.status = 13
                  }


                  if (status === 12 || status === 13) {
                    this.rejectReservation.btnLoading = false;
                    this.rejectReservation.infoModal = false;

                   this.activities[2].content =  this.userId ? "Pedido Cancelado" : "Pedido Recusado";
                  this.activities[2].timestamp = this.userId ? "Você cancelou o pedido!" : "Você recusou o pedido!";
                  this.activities[2].type = 'danger';
                  this.activities[2].icon = 'el-icon-circle-close';

                  this.rejectReservation.btnLoading = false;
                  this.rejectReservation.infoModal = false;
                  this.rejectReservation.btnStatus = true;
                  this.approveReservation.btnStatus = false;
                  this.chat.btnStatus = true;
                  this.rejectReservation.confirmationModal = false;
                  }

                   this.booking.bookingDetailsModal = false
                   await this.getOrders();
                }
              })
              .catch(err => {
                this.loading.status.checking = false;
                this.rejectReservation.btnLoading = false;
                this.approveReservation.btnLoading = false;
                this.helpModal.button.state = false
                this.helpModal.cancel.state = false
                this.$message.error(err);
                if (status === 6 || status === 16) {
                  this.helpModal.button.hidden = true
                  this.helpModal.cancel.hidden = true
                  this.approveReservation.hidden = true
                }
                 this.booking.bookingDetailsModal = false
              });
              await this.getOrders();

          } catch (e) {
            new Error(e)
          }


        },

        getNow: function () {
            const today = new Date();
            const date = today.getDate() + '/' + (today.getMonth() + 1) + '/' + today.getFullYear();
            const time = today.getHours() + ":" + today.getMinutes()
            this.timestamp = date + ' às ' + time;
        },

        bookModal(obj) {
            this.booking.bookingDetailsModal = true;
            this.bookObj = obj;
            this.getUser(obj.customer.email)
        },

        async bookModalClose() {
           this.booking.bookingDetailsModal = false
           this.approveReservation.hidden = false
           this.helpModal.button.hidden = false
           this.userNivelData = {}
           await this.getOrders();
        },

        filterStatus(value, row) {
            return row.status === value;
        },

        createTimeLineData (content, timestamp, type, obs) {
           return {
              content,
              timestamp: this.$moment(timestamp).format("DD-MM-YYYY [às] H:mm:ss"),
              type: type === 'danger' ? 'danger' :
                 type === 'warning' ? 'warning' :
                 type === 'info' ? 'info' :
                    'success',
              icon: type === 'danger' ? 'el-icon-circle-close' :
                 type === 'warning' ? 'el-icon-warning-outline' :
                 type === 'info' ? 'el-icon-info' :
                    'el-icon-success',
              obs
           }
        },

        timeLineStatus(obj) {

           this.activities = []

            let index = obj.length - 1;
            this.bookObj.status = obj[index].statusChangedTo;

            let timelineArr = []

            obj.map((v) => {
               timelineArr.push(this.createTimeLineData(v.info ? v.info : '', v.changedOn ? v.changedOn : this.$moment().format("DD-MM-YYYY [às] H:mm:ss"), v.type ? v.type : 'success', v.obs ? v.obs : ''))
            })

           this.activities = timelineArr
        },

        bikeData: function (id) {

          BikeService.getBikeById(id)
            .then((response) => {
              if (response) {
                this.bike = response.data.data;
                this.tempBike = response.data.data;
              }
            })
            .catch(err => {
              this.$message.error(err);
            });
        },

        sendRequestNewDates() {
          this.bookingDates.btnNewDateLoading = true;
          setTimeout(()=> {
            this.bookingDates.btnNewDateLoading = false;
            this.bookingDates.btnNewDateState = false;
            this.bookingDates.btnState = true;
            this.$alert('Sua solicitação de alteração de datas foi enviada com sucesso. Aguarde a confirmação do anfitrião.', 'Solicitação enviada com sucesso!', {
              confirmButtonText: 'Ok, obrigado(a)',
            });
          }, 1000)
        },

        clearSelectDatesComponent() {
          setTimeout(() => {
            setTimeout(() => {
              this.$refs.selectDates.resetCalendar();
              this.forceRerender()
            }, 10)

            this.bike = this.tempBike
          }, 20)

        },

        forceRerender() {
        // Remove my-component from the DOM
        this.renderComponent = false;

        this.$nextTick(() => {
          // Add the component back in
          this.renderComponent = true;
        });
      },

       haveChangeBookingDate(logsStatus) {
          let newDates = {}
           logsStatus.map(v => {
            if (v.resources) {
              if (v.resources.changeOfDates) {
                newDates.checkin = v.resources.changeOfDates.checkin
                newDates.checkout = v.resources.changeOfDates.checkout
                newDates.dailyValue = v.resources.changeOfDates.dailyValue
              }
            }
          })

          this.newDates = newDates

        },

       formatDate(date) {
          return this.$moment(date).utc().format("DD-MM-YYYY");
       },

       chargeBroken(orderId, type) {
          this.$refs['formBroken'].validate((valid) => {

             if (type === "BROKEN_CHARGING") {
                if (!valid) {
                   this.$message.warning('Por favor, preencha todos os campos corretamente!');
                   this.loading.chargeNewDaily = false
                   return false;
                } else {
                   this.chargeNewDaily(orderId, type)
                }
             }
          })
       },

       chargeNewDaily(orderId, type) {
           let msn, title;
           switch (type) {
              case 'BROKEN_CHARGING':
                 msn = 'Você está cobrando um valor personalizado. Você poderá efetuar essa ação até que a soma dos valores resultem no valor total da bicicleta ref. a este pedido.';
                 title = 'Cobrar valor personalizado'
              break;
              case 'BIKE_COMPLETE_CHARGE':
                 msn = 'Você está cobrando o valor integral da bicicleta, ref. a este pedido. Caso o cartão do usuário não tenha o limite correspondente ao valor, você poderá tentar cobrar valores personalizados.';
                 title = 'Cobrar valor integral da bicicleta'
                 break;
                 default:
                    msn = 'O ciclista ainda não devolveu a bike? Você tem o direito de cobrar uma diária adicionar hoje.';
                    title = 'Cobrar Diária Adicional'
           }

          this.$confirm(msn, title, {
             confirmButtonText: 'Ok, Efetuar cobrança',
             cancelButtonText: 'Aguardar',
             type: 'info'
          }).then(async () => {

             let amount = this.formBrokenCharging.amount > 0 ? this.formBrokenCharging.amount : ''

             try {
                this.loading.chargeNewDaily = true
                const charge = await OrderService.charge({info: 'Cobrança de Diária Adicional - Atraso na entrega.', orderId, amount})
                if (charge) {
                   this.$message({
                      type: 'success',
                      message: charge.data.message
                   });
                   this.loading.chargeNewDaily = false
                   this.approveReservation.chargeNewDaily = true
                } else {
                   this.firstBrokenCharging = true
                   this.loading.chargeNewDaily = false
                }
             } catch (e) {
                this.loading.chargeNewDaily = false
             }

          }).catch(() => {

          });
        },

       priceValidation(rule, value, callback) {


          let formatedPrice = numeral(value);

          if (formatedPrice._value < 0) {
             this.netValue = numeral(0.00).format('$ 0,0.00');
          }

          if (!formatedPrice._value || formatedPrice._value === 0.00) {
             return callback(new Error('Digite o valor'));
          }

          if (formatedPrice._value > 100) {
             return callback(new Error('Máximo: R$ 100,00'));
          }


          callback();

       },

       handleDatesToday(date) {
          //No mesmo dia
          return this.$moment().isSame(this.$moment(date), 'day')
       },

       handleDateToday(date) {
          return this.$moment().utc().diff(date, 'h') > 0
       },

       handleDatesTomorrow(date) {
          //no dia seguinte
          return this.$moment().utc().isSame(this.$moment(date).utc().add(1, 'day'), 'day')
       },

       checkRequestedDateChange(book) {
         return (book.logs.status.filter(v => v.resources ? v.resources.changeOfDates : 0)).length
       },

       resetForm(formName) {
          this.$refs[formName].resetFields();
       },

       // eslint-disable-next-line no-unused-vars
       async openChat(bookObj) {

          this.bookObj = bookObj

          if (this.bookObj.orderN) {
             setTimeout(() => {
                this.chat.open = true
             }, 50)
          }
       },

       async closeChat() {
          await this.getOrders();
          this.chat.open = false
       },

       openRating(book) {
          // eslint-disable-next-line no-unused-vars
           const id = book._id
           this.rating.modal = true
            this.bookObj = book
       },

       async sendRating(formName) {

           if (!this.formRating.rate) {
              this.rating.error = true
           }

          this.$refs[formName].validate(async (valid) => {

             this.rating.loading = true;

             if (valid && this.formRating.rate) {

                const payload = {
                   namespace: this.userId ? 'Bike' : 'User',
                   rate: this.formRating.rate,
                   comment: this.formRating.comment,
                   order: this.bookObj._id,
                   forUserId: this.userId ? this.bookObj.owner._id : this.bookObj.customer._id,
                   bike: this.userId ? this.bookObj.bike._id : undefined,
                   resources: {}
                }

               try  {
                  const rating = await UserService.postRating(payload)

                  if (rating) {
                     this.$message.success("Avaliação enviada com sucesso. Obrigado!");
                     this.rating.modal = false
                     this.formRating.rate = null
                     this.formRating.comment= ''
                     this.rating.loading = false;

                     if (this.userId) {
                        this.bookObj.resources.customerRating = true
                     }

                     if (!this.userId) {
                        this.bookObj.resources.ownerRating = true
                     }

                     await this.getOrders();
                  }
               } catch (e) {
                  this.$message.warning('Algo deu errado. Tente novamente mais tarde.');
                  this.rating.loading = false;
               }

             } else {
                this.$message.warning('Por favor, preencha todos os campos corretamente!');
                this.rating.loading = false;
                return false;
             }
          })

       },

       leave_RejectRating(done) {
          this.$confirm('Espere um pouco: a sua avaliação é muito importante para nós!. Tem certeza de que quer sair?')
             .then(() => {
                this.rating.modal = false
                this.formRating.rate = null
                this.formRating.comment= ''
                done();
             })
             .catch(() => {
             });
       },

       async getUser(email) {
          const res = await UserService.getUser({email})
          this.userNivelData = res.data.user
       }

    },

    computed: {

      checkinDate: function () {
        return this.$moment(this.bookObj.period.checkin).add(1, 'days').format("DD-MM-YYYY");
      },

      checkoutDate: function () {
        return this.$moment(this.bookObj.period.checkout).add(1, 'days').format("DD-MM-YYYY");
      },

      checkinDateChanged: function () {
        if (this.selectDatesQuery.dateCheckin) {
          return {
            formatedDate: this.$moment(this.selectDatesQuery.dateCheckin).format("DD-MM-YYYY"),
            date: this.selectDatesQuery.dateCheckin
          }
        }
        if (this.newDates) {
          return {
            formatedDate: this.$moment( this.newDates.checkin ).utc().format("DD-MM-YYYY"),
            date: this.newDates.checkin
          }
        }
        return false

      },

      checkoutDateChanged: function () {
        if (this.selectDatesQuery.dateCheckout) {
          return  {
            formatedDate: this.$moment(this.selectDatesQuery.dateCheckout).format("DD-MM-YYYY"),
            date: this.selectDatesQuery.dateCheckout
          }
        }
        if (this.newDates) {
          return {
            formatedDate: this.$moment(this.newDates.checkout).utc().format("DD-MM-YYYY"),
            date: this.newDates.checkout
          }
                }
        return false
      },

      userName: function () {
        return this.userId ? this.bookObj.customer.firstName + ' ' + this.bookObj.customer.lastName : this.bookObj.owner.firstName + ' ' + this.bookObj.owner.lastName
      },

      getStatus: function () {
        return this.bookObj.status
      },

      canChangeDates: function () {
        return this.bookObj.status === 5 ||
          this.bookObj.status === 6
      },

      selectDatesQuery() {
        return this.$store.state.selectDates.dates;
      },

      bikeObj() {
       return this.bike
      },

      dailyNumber: function () {

        let checkin = this.newDates ?
          this.$moment(this.newDates.checkin).format("YYYY-MM-DD") :
          this.selectDatesQuery.dateCheckin;

        let checkout = this.newDates ?
          this.$moment(this.newDates.checkout).format("YYYY-MM-DD") :
          this.selectDatesQuery.dateCheckout;

         return dailyNumber(checkin, checkout);
      },

      //total do pedido
      totalOrder() {
         return calcAmountOrder(this.bookObj.daily, this.bookObj.bike.dailyValue)
      },

      totalOrderFormated() {
        return this.$options.filters.currency(this.totalOrder)
      },

      //total do pedido, caso atualizado as datas de checkin e checkou
      totalOrderUpdated() {
        if (this.dailyNumber) {

          if (this.newDates) {
            return calcAmountOrder(this.dailyNumber, this.newDates.dailyValue)
          }

          return calcAmountOrder(this.dailyNumber, this.bike.dailyValue)
        }
        return 0
      },

      totalOrderUpdatedFormated() {
        return this.$options.filters.currency(this.totalOrderUpdated)
      },

      //Total do valor da diária atual da bike
      currentFormattedDailyValue() {
        return this.$options.filters.currency(this.userId ? this.bike.dailyValue : this.newDates.dailyValue)
      },

      totalOrderValueUpdated() {
        let result = {
          total: 0,
          title: '',
          info: '',
        }
        if (this.totalOrder < this.totalOrderUpdated) {
          result.total =  this.totalOrderUpdated - this.totalOrder
          result.title =  this.newDates ? 'Você recebera um novo valor de:' : 'Você terá uma nova cobrança no valor de:'
          result.info =   this.newDates ? '' :  `Após aprovado pelo anfitrião, será <b>cobrado</b> este valor do seu cartão de crédito!`
        }

        if (this.totalOrder > this.totalOrderUpdated) {
          result.total =  this.totalOrder - this.totalOrderUpdated
          result.title =  this.newDates ? 'O ciclista receberá um estorno no valor de:' : 'Você recebera um estorno no valor de:'
          result.info =  this.newDates ? '' : `Após aprovado pelo anfitrião, será <b>estornado</b> este valor para o seu cartão de crédito!`
        }

       if (this.totalOrder === this.totalOrderUpdated) {
         result.total =  0
         result.title =  ''
         result.info =  ''
       }

        return result

      },

      totalOrderValueUpdatedFormated () {
        return {
          total: this.totalOrderValueUpdated.total === 0 ? '' : this.$options.filters.currency(this.totalOrderValueUpdated.total),
          title: this.totalOrderValueUpdated.title,
          info: this.totalOrderValueUpdated.info
        }
      },

      rateFormated () {
        return this.$options.filters.currency(this.bookObj.rate)
      },

      isPJ() {

         let userType;

         if (this.bookObj.owner.resources) {
            userType = this.bookObj.owner.resources.type === 'pj' || false
         } else {
            userType = this.$store.state.user.data.additionalInformation.type === 'pj' || false
         }
         return userType
      },

    },

    watch: {
        bookObj: function (n) {
           this.activities = []

           this.$store.dispatch('selectDates/clearDates');

           let now = this.$moment()
           //now = this.$moment('2021-02-08T00:00:00.000+00:00')

           this.bikeData(n.bike._id)

            if (n.logs.viewed === undefined) {
                this.viewOrder(n._id);
            }

           if (!this.userId) {
              this.haveChangeBookingDate(n.logs.status)
           }

            //this.timeLineStatus(n.logs.status)

            let checkin = this.bookObj.period.checkin;
            let checkout = this.bookObj.period.checkout;

            let diff = this.$moment(checkout).diff(checkin, 'days');

            checkin = this.$moment(checkin)

           // Ativa o botão de alteração de datas.
           this.changeDatesToday = this.handleDatesToday(n.createdAt) && this.checkRequestedDateChange(n) === 0 && !this.handleDateToday(n.period.checkin)

           this.changeDatesTomorrow = this.handleDatesTomorrow(n.createdAt) && this.checkRequestedDateChange(n) < 2 && !this.handleDateToday(n.period.checkin)

           // Ativa ou remove o botão de rejeitar a reserva
           //this.activeAproveReproveButton = this.handleDatesToday(n.createdAt)


              // usado para ativar o botão do checkin quando estiver no dia para buscar a bike
            this.activeCheckin = ( this.$moment(now).diff(checkin, 'h') > 0);

            // usado para ativar o botão do checkout quando estiver a 1 dia para entregar a bike
            this.activeCheckout = ( this.$moment(now).diff(checkout, 'h') > -24);

            //usado para ativar o botão para cobrar a primeira diária adicional.
           this.activeAdditionalDaily = ( this.$moment(now).diff(checkout, 'h') > 23);

           this.bookObj.daily = diff

           //console.log('now', now)

           // Usado para saber se o pedido está atrasado.
           const handleLateDay = now.diff(checkout, 'd');

           // Usado para verificar se já foi cobrado alguma diária adicional
           this.additionalDailyCharges = n.resources.additionalCharge !== undefined && n.resources.additionalCharge.length > 1 || false

           //Pode cobrar 2 vezes a partir do dia seguinte do checkout
           if (handleLateDay > 0 && handleLateDay < 2 && n.resources.additionalCharge !== undefined && n.resources.additionalCharge.length > 0) {
              this.approveReservation.chargeNewDaily = true;
           }

            // Verifica se já foi cobrado o valor integral da bike
           this.bike_complete_charging = n.resources.additionalCharge !== undefined && n.resources.additionalCharge.filter(v => v ? v.type === 'BIKE_COMPLETE_CHARGING' : false)

           // Verifica se já foi cobrado alguma valor personalizado
           this.brokenCharging = n.resources.additionalCharge !== undefined && n.resources.additionalCharge.filter(v => v ? v.type === 'BROKEN_CHARGING' : false)

           if (handleLateDay > 2 && !this.bike_complete_charging.length) {
              this.approveReservation.chargeNewDaily = false;
           }

           if (this.bike_complete_charging.length && this.bike_complete_charging[0].type === 'BIKE_COMPLETE_CHARGING') {
              this.approveReservation.chargeNewDaily = true;
           }

           let brokenChargingValue = 0.00

           if (this.brokenCharging) {
              this.brokenCharging.map(b => b.pay.map(v => v.payments.map(p => {
                 brokenChargingValue += p.amount
              })))
           }
           if (brokenChargingValue === n.bike.bikeValue) {
              this.brokenChargingValueComplete = true
           }

        },
        'bookObj.logs.status': function (n) {
            this.timeLineStatus(n)
        },
        searchQuery: function () {
            this.getOrders()
        },
      async $route(to) {
        if (to.params.page === 'pedidos') {
         await this.getOrders();
        }
      },
      'formRating.rate' : function (n) {
         if (n) {
            this.rating.error = false
         }
      }
    }
};
</script>

<style lang="scss">
.form-brokenCharging {
   &.el-form--inline {
      .el-form-item {
         margin-bottom: 0 !important;
         margin-top: -10px;

         .el-button {
            height: 40px;
            @media (max-width: 767.98px) {
               border-radius: 5px !important;
            }
         }

         .el-input {
            input {
               height: 39px;
            }
         }
      }
   }
}

.el-badge__content.is-fixed.is-dot {
   top: 5px;
}

.link-bike {
   vertical-align: unset;
}

.btn-rate {

   &.el-rate {
      height: auto;
      line-height: inherit;
   }

   .el-rate__icon {
      font-size: 35px;
   }

   .el-rate__text {
      color: rgb(247, 186, 42) !important;
      display: block;
      margin: 10px 0;
   }
}

.dashboard.my-reservations .datepicker__mini .datepicker__input {
   width: 80% !important;
}

.el-timeline-item {
   word-break: break-word;
}

.timeline-wrap {
   height: 100%;
   overflow: auto;
   padding-left: 5px;
   padding-right: 10px;

   .el-card__body {
      padding: 10px 15px;
   }

   .el-timeline-item__node--info {
      background-color: #17a2b8 !important
   }
}

.search-input {
    width: 90%;
    max-width: 380px;
}

</style>
